import React from "react";
import { Link } from "react-router-dom";
import { streamers, getStreamerDisplayName } from "../App";
import CornerEmote from "./CornerEmote";

// Create a mapping of streamer IDs to their avatar images
const streamerAvatars = {
  arrowwoods:
    "https://static-cdn.jtvnw.net/jtv_user_pictures/2a4b0efe-7021-469f-9f14-8d41d94f2205-profile_image-300x300.jpeg",
  dobrorulitura:
    "https://static-cdn.jtvnw.net/jtv_user_pictures/5e13d056-5040-4596-9574-4e093957b89e-profile_image-300x300.png",
  archiedos:
    "https://static-cdn.jtvnw.net/jtv_user_pictures/5997dd2b-3019-4b07-8635-ec85f05f4406-profile_image-300x300.png",
};

function Home() {
  return (
    <div className="home-container">
      <CornerEmote />
      <div className="streamers-list">
        {streamers.map((streamer) => (
          <Link to={`/${streamer}`} key={streamer} className="streamer-card">
            <div className="avatar-container">
              <img
                src={streamerAvatars[streamer]}
                alt={`${getStreamerDisplayName(streamer)} avatar`}
                className="streamer-avatar"
              />
            </div>
            <h2 className="streamer-name">
              {getStreamerDisplayName(streamer)}
            </h2>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Home;
